import { initHttp } from '../../utils/http';
const http = initHttp();
export function initRefreshTokenWrapper(refreshTokenUrl) {
  let authHeaders = {};
  let refreshedAt = 0;
  function isRecentlyRefreshed() {
    return new Date().valueOf() - refreshedAt < 10000;
  }

  // wrap request with refresh auth token
  return function (method) {
    // add auth token to request
    const methodWithAuthHeaders = function () {
      const originalHeaders = (arguments[2] || {}).headers || {};
      return method.call(this, arguments[0], arguments[1] || {}, {
        ...arguments[2],
        headers: {
          ...authHeaders,
          ...originalHeaders
        }
      });
    };

    // refresh token on auth error and retry call
    return http.catchError(methodWithAuthHeaders, function (reason, callMethod) {
      if (reason.code === 403 && !isRecentlyRefreshed()) {
        return http.post(refreshTokenUrl).then(function (response) {
          authHeaders = response.data.set_headers || {};
          refreshedAt = new Date().valueOf();
          return callMethod();
        });
      }
      return Promise.reject(reason);
    });
  };
}